export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84')
];

export const server_loads = [];

export const dictionary = {
		"/": [8],
		"/admin": [11,[2]],
		"/admin/dashboard": [12,[2]],
		"/admin/equipes": [13,[2]],
		"/admin/equipes/novo": [15,[2]],
		"/admin/equipes/[id]": [14,[2]],
		"/admin/guest-tokens": [16,[2]],
		"/admin/locais": [17,[2]],
		"/admin/locais/novo": [19,[2]],
		"/admin/locais/[id]": [18,[2]],
		"/admin/mentores": [20,[2]],
		"/admin/mentores/novo": [22,[2]],
		"/admin/mentores/[id]": [21,[2]],
		"/admin/projeto/[group]/[project]/actions": [23,[2,3]],
		"/admin/projeto/[group]/[project]/manage/edit": [24,[2,3]],
		"/admin/projeto/[group]/[project]/manage/progress": [25,[2,3]],
		"/admin/projeto/[group]/[project]/mentorias": [26,[2,3]],
		"/admin/projeto/[group]/[project]/monitoring": [27,[2,3]],
		"/admin/projeto/[group]/[project]/resume": [28,[2,3]],
		"/admin/projeto/[group]/[project]/team": [29,[2,3]],
		"/admin/reviewers": [30,[2]],
		"/admin/turmas": [31,[2]],
		"/admin/turmas/novo": [33,[2]],
		"/admin/turmas/[id]": [32,[2]],
		"/admin/usuarios": [34,[2]],
		"/admin/usuarios/acoes": [37,[2]],
		"/admin/usuarios/[id]": [35,[2]],
		"/admin/usuarios/[id]/acessos": [36,[2]],
		"/exemplos/mentoria-cards": [38],
		"/invitation": [39],
		"/lgpd": [40],
		"/lgpd/mentor": [41],
		"/lgpd/privacy": [42],
		"/lgpd/terms": [43],
		"/manager": [44,[4]],
		"/manager/actions": [53,[4]],
		"/manager/equipes": [54,[4]],
		"/manager/equipes/novo": [56,[4]],
		"/manager/equipes/[id]": [55,[4]],
		"/manager/mentores": [57,[4]],
		"/manager/mentores/[id]": [58,[4]],
		"/manager/methodology": [59,[4]],
		"/manager/methodology/[sectionId]/[outputId]": [60,[4]],
		"/manager/methodology/[sectionId]/[outputId]/[toolId]": [61,[4]],
		"/manager/turmas": [62,[4]],
		"/manager/turmas/[id]": [63,[4]],
		"/manager/users": [64,[4]],
		"/manager/usuarios": [65,[4]],
		"/manager/usuarios/[id]": [66,[4]],
		"/manager/usuarios/[id]/acessos": [67,[4]],
		"/manager/[group]": [45,[4]],
		"/manager/[group]/[project]/actions": [46,[4,5]],
		"/manager/[group]/[project]/manage/edit": [47,[4,5]],
		"/manager/[group]/[project]/manage/progress": [48,[4,5]],
		"/manager/[group]/[project]/mentorias": [49,[4,5]],
		"/manager/[group]/[project]/monitoring": [50,[4,5]],
		"/manager/[group]/[project]/resume": [51,[4,5]],
		"/manager/[group]/[project]/team": [52,[4,5]],
		"/mentor": [68],
		"/methodology": [69],
		"/open-innovation": [70,[6]],
		"/open-innovation/[questionnaire]": [71,[6]],
		"/profile": [72],
		"/project": [73,[7]],
		"/project/hard-skills": [74,[7]],
		"/project/minutes": [75,[7]],
		"/project/monitoring": [76,[7]],
		"/project/rating": [77,[7]],
		"/project/repository": [78,[7]],
		"/project/resume": [79,[7]],
		"/project/scheduling": [80,[7]],
		"/project/soft-skills": [81,[7]],
		"/share-project": [82],
		"/teams": [83],
		"/videos": [84],
		"/[section]/[output]": [9],
		"/[section]/[output]/[tool]": [10]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';